import { ButtonBase, useTheme } from "@mui/material";
import type { FC, Ref } from "react";
import { AmountWithCurrency } from "web_myplann/Shared/Components/AmountWithCurrency";
import type { AmountStepperSize } from "web_myplann/Shared/Types/AmountStepperSize";
import { numberFormatter } from "web_myplann/Shared/Utils/numberFormatters";

type Props = {
	size: AmountStepperSize;
	id?: string;
	buttonRef?: Ref<HTMLButtonElement>;
	value: number;
	color?: string;
	disabled?: boolean;
	onClick: () => void;
};

export const AmountStepperValue: FC<Props> = ({
	size,
	id,
	buttonRef,
	value,
	color,
	disabled,
	onClick,
}) => {
	const { amountStepper } = useTheme();
	const { variant, suffixVariant, suffixColor, box } =
		amountStepper.value[size];

	return (
		<ButtonBase
			id={id}
			ref={buttonRef}
			disabled={disabled}
			disableRipple
			onClick={onClick}
			sx={{ ...box, justifyContent: "center" }}
		>
			<AmountWithCurrency
				amount={numberFormatter.format(value)}
				variant={variant}
				color={color}
				suffixVariant={suffixVariant}
				suffixColor={suffixColor}
			/>
		</ButtonBase>
	);
};
